import { render, staticRenderFns } from "./LoyaltySettingAdjustments.vue?vue&type=template&id=4693afa4&scoped=true&"
import script from "./LoyaltySettingAdjustments.vue?vue&type=script&lang=js&"
export * from "./LoyaltySettingAdjustments.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltySettingAdjustments.vue?vue&type=style&index=0&id=4693afa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693afa4",
  null
  
)

export default component.exports